module.exports = __webpack_public_path__ + "static/img/016石油设计院.19c7776.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/016石油设计院.jpg
// module id = E4Yd
// module chunks = 0